import script from "./FilterSearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterSearchBar.vue?vue&type=script&setup=true&lang=js"

import "./FilterSearchBar.vue?vue&type=style&index=0&id=0c427930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c427930"]])

export default __exports__